module.exports = __webpack_public_path__ + "906ac8aa0ece817c6f1c4750d7ede870.jpg";